import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TableViewCIIComponent } from './table-view-cii.component';

const routes: Routes = [
  {
    path: '',
    component: TableViewCIIComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TableViewCIIRoutingModule {}
